import BaseModel from "./BaseModel";
import { LangKey } from "./LangKey";
import Resource from "./Resource";

class Hub extends BaseModel {
  static PUBLIC_PRIVATE_COLORS = {
    private: "orange",
    public: "green",
  };

  id: number;
  referenceId: string;
  latitude: number;
  longitude: number;
  address: string;
  zipCode: string;
  city: string;
  country: string;
  description: string;
  infoUrls: string;
  timezone: string;
  access: string;
  name?: string;
  resources?: Resource[] | any;
  tspId: number;
  static __dates = [];
  static __access = ["public", "private"];
  constructor(data) {
    super(data, Hub.__dates);
    this.id = data.id;
    this.referenceId = data.referenceId;
    this.latitude = data.latitude;
    this.longitude = data.longitude;
    this.address = data.address;
    this.zipCode = data.zipCode;
    this.city = data.city;
    this.country = data.country;
    this.description = data.description;
    this.infoUrls = data.infoUrls;
    this.timezone = data.timezone;
    this.access = data.access;
    this.name = data.name;
    this.resources = data.resources;
    this.tspId = data.tspId;
  }
}

export default Hub;

export const encodeInfoUrls = (infoUrls: Record<string, string>) : string => {
  const data = {};
  let empty = true;
  for (let lk of [LangKey.EN, LangKey.SV]) {
    if (infoUrls[lk] !== undefined && infoUrls[lk] !== '') {
      data[lk] = infoUrls[lk];
      empty = false;
    }
  }

  if (empty) {
    return null;
  }

  return JSON.stringify(data);
}
